import { t } from 'i18next';

import { RegexFlag } from '../../../../../gamma-api';

const PYTHON_SPECIFIC_GROUP_RE = /\(\?(?:[aiLmsux-]+:?|P[<=]|#|\()/;

const toBrowserRegexFlags = (flags?: RegexFlag[]): string => {
  const browserFlags = new Set<string>();
  if (flags?.includes(RegexFlag.IgnoreCase)) {
    browserFlags.add('i');
  }
  if (flags?.includes(RegexFlag.Multiline)) {
    browserFlags.add('m');
  }
  if (flags?.includes(RegexFlag.DotAll)) {
    browserFlags.add('s');
  }
  return Array.from(browserFlags).join('');
};

const canValidateInBrowser = (pattern: string): boolean => !PYTHON_SPECIFIC_GROUP_RE.test(pattern);

const isBrowserValidRegex = (pattern: string, flags?: RegexFlag[]): boolean => {
  if (!canValidateInBrowser(pattern)) {
    return true;
  }

  try {
    // eslint-disable-next-line security/detect-non-literal-regexp
    new RegExp(pattern, toBrowserRegexFlags(flags));
    return true;
  } catch {
    return false;
  }
};

export const validateRegexPatterns = (patterns?: string[], flags?: RegexFlag[]): boolean | string => {
  if (!patterns?.length) {
    return false;
  }

  return patterns.every((pattern) => isBrowserValidRegex(pattern, flags))
    ? true
    : t('Agent: Guardrails: RegexCheck: Patterns: Invalid');
};
